import React, { Fragment } from 'react';
import { func } from 'prop-types';
import { createPortal } from 'react-dom';

const withDialogPortal = (DialogComponent, propName = 'withDialog') => (WrappedComponent) => {
  class withDialog extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        open: false,
        props: {},
      };

      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.controller = this.controller.bind(this);
    }

    getChildContext() {
      return {
        [propName]: this.controller,
      };
    }

    handleOpen(props) {
      this.elem = document.createElement('div');
      this.elem.className = propName;
      document.body.appendChild(this.elem);

      this.setState({ open: true, props });
    }


    handleClose(e) {
      e.stopPropagation();
      this.setState({ open: false, props: {} }, () => {
        document.body.removeChild(this.elem);
        delete this.elem;
      });
    }

    controller(props) {
      this.handleOpen(props);
    }

    render() {
      const { open } = this.state;

      return (
        <Fragment>
          <WrappedComponent
            {...{ [propName]: this.controller }}
            {...this.props}
          />
          {open && createPortal(
            <DialogComponent
              {...this.props}
              {...this.state.props}
              onClose={this.handleClose}
              open
              onClick={(e) => { e.stopPropagation(); }}
            />,
            this.elem,
          )}
        </Fragment>
      );
    }
  }

  withDialog.childContextTypes = {
    [propName]: func.isRequired,
  };

  return withDialog;
};

export default withDialogPortal;
